export default __webpack_public_path__ + "static/media/ISSO CLASS-1 EXAM PATTERN 2025.b61d3fcb.pdf";